import React, { useEffect, useState } from "react";
import Accordion from "../Accordion";
import PartyForm from "../PartyForm";
import api from "../../api/api";

const Page2 = ({
  GlId, user, selectedParty, setSelectedParty,
  isPartySectionOpen,
  setIsPartySectionOpen,
  searchTerm,
  setSearchTerm,
  handleSelectParty,
  handleAddNewParty,
  partyData,
  isEditingParty,
  isCreating,
  handlePartyInputChange,
  handleSaveParty,
  handleCancelEditParty,
  useDeliveryPoint,
  handleUseDeliveryPointChange,
  deliveryPointSearchTerm,
  setDeliveryPointSearchTerm,
  selectedDeliveryPoint,
  handleSelectDeliveryPoint,
  deliveryPointData,
  isEditingDeliveryPoint,
  setIsEditingDeliveryPoint,
  handleDeliveryPointInputChange,
  handleSaveDeliveryPoint,
  handleCancelEditDeliveryPoint,
  selectedDespatchThrough,
  setSelectedDespatchThrough,
  vehicleNo,
  setVehicleNo,
  handleDeliveryPointSearch,
  selectedVehicleType,
  setSelectedVehicleType,
  vehicleTypeOptions,
  despatchThroughOptions,
  ewayBillNo,
  setEwayBillNo,
  despatchRef,
  setDespatchRef,
  isTransportSectionOpen,
  setIsTransportSectionOpen,
  setPage,
  isPage2NextDisabled,
  isDeliverySectionOpen,
  setIsDeliverySectionOpen,
  setIsEditingParty,
}) => {
  const [partyList, setPartyList] = useState([]);
  const [deliveryPointList, setDeliveryPointList] = useState([]);
  const [showPartyList, setShowPartyList] = useState(false);
  const [showDeliveryPointList, setShowDeliveryPointList] = useState(false);
  useEffect(() => {
    if (!GlId || !user) return;
    const fetchParty = async () => {
      try {
        const data = await api.getPartyTypeGl(GlId, user);
        const table = data?.Table;
        if (Array.isArray(table) && table.length > 0) {
          const mapped = table.map((p) => ({
            PId: p.Vid,
            PCode: p.VCode,
            PName: p.Vname?.trim(),
            Address: p.Address,
            City: p.City,
            State: p.State,
            Country: p.Country || "",
            PinCode: p.PinCode,
            PartyType: p.PartyType,
            GSTIN: p.GSTIN,
          }));
          setPartyList(mapped);
          setDeliveryPointList(mapped);
          setSelectedParty(mapped[0]);
        } else {
          setPartyList([]);
          setDeliveryPointList([]);
          setSelectedParty(null);
        }
      } catch (err) {
        console.error("Error fetching party:", err);
      }
    };
    fetchParty();
  }, [GlId, user, setSelectedParty]);


  const displayedParties = partyList.filter(
    (p) =>
      p.PName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.PCode?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedDeliveryPoints = deliveryPointList.filter(
    (p) =>
      p.PName?.toLowerCase().includes(deliveryPointSearchTerm.toLowerCase()) ||
      p.PCode?.toLowerCase().includes(deliveryPointSearchTerm.toLowerCase())
  );
  const handleNext = async () => {
    try {
      const payload = {
        GlId,
        UserName: user,
        GlParty: selectedParty ? [{
          Vid: selectedParty.PId,
          VCode: selectedParty.PCode,
          VName: selectedParty.PName,
          Address: selectedParty.Address,
          City: selectedParty.City,
          State: selectedParty.State,
          Country: selectedParty.Country,
          PinCode: selectedParty.PinCode,
          GSTIN: selectedParty.GSTIN,
          PartyType: selectedParty.PartyType
        }] : [],
        GlPartyDelivery: useDeliveryPoint && selectedDeliveryPoint ? [{
          Vid: selectedDeliveryPoint.PId,
          VCode: selectedDeliveryPoint.PCode,
          VName: selectedDeliveryPoint.PName,
          Address: selectedDeliveryPoint.Address,
          City: selectedDeliveryPoint.City,
          State: selectedDeliveryPoint.State,
          Country: selectedDeliveryPoint.Country,
          PinCode: selectedDeliveryPoint.PinCode,
          GSTIN: selectedDeliveryPoint.GSTIN,
          PartyType: selectedDeliveryPoint.PartyType
        }] : [],
        GlTransport: [{
          DespatchThrough: selectedDespatchThrough,
          VehicleType: selectedVehicleType,
          VehicleNo: vehicleNo,
          EwayBillNo: ewayBillNo,
          DespatchRef: despatchRef
        }]
      };

      const response = await api.postGlPartyDetailsSave(payload);
      const returnedGlId = response?.Table?.[0]?.GlId; // matches your API response

      if (returnedGlId) {
        console.log("Saved GlId:", returnedGlId);
        // Optionally store it in state or localStorage
        setPage(3); // move to next step
      } else {
        console.error("No GlId returned from API");
      }
    } catch (err) {
      console.error("Error saving party details:", err);
    }
  };
  return (
    <>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 border-b pb-4">
        Party & Transport (Step 2/5)
      </h1>

      <div className="space-y-4">
        <Accordion
          title="Party Details"
          isOpen={isPartySectionOpen}
          setIsOpen={setIsPartySectionOpen}
          summary={
            selectedParty
              ? `${selectedParty.PName} (${selectedParty.PCode})`
              : "No party selected"
          }
        >
          <div className="space-y-4">
            <div className="space-y-2 relative">
              <label
                htmlFor="partySearch"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Select or Add Party
              </label>
              <input
                type="text"
                id="partySearch"
                placeholder="Search by Party Name or Code..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setShowPartyList(true)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
              />
              {showPartyList && (
                <ul className="absolute z-20 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                  {displayedParties.map((party) => (
                    <li
                      key={party.PId}
                      onClick={() => {
                        handleSelectParty(party);
                        setShowPartyList(false);
                      }}
                      className="p-2 hover:bg-indigo-100 cursor-pointer"
                    >
                      {party.PName} ({party.PCode})
                    </li>
                  ))}
                  <li
                    onClick={() => {
                      handleAddNewParty();
                      setShowPartyList(false);
                    }}
                    className="p-2 hover:bg-indigo-100 cursor-pointer bg-indigo-50 text-indigo-700 font-semibold"
                  >
                    ＋ Add New Party
                  </li>
                </ul>
              )}
            </div>

            <PartyForm
              party={partyData}
              isEditing={isEditingParty}
              isCreating={isCreating}
              onChange={handlePartyInputChange}
              onSave={handleSaveParty}
              onCancel={handleCancelEditParty}
              setIsEditing={setIsEditingParty}
              title={isCreating ? "Add New Party" : "Party Details"}
            />
          </div>
        </Accordion>

        <Accordion
          title="Delivery Point"
          isOpen={isDeliverySectionOpen}
          setIsOpen={setIsDeliverySectionOpen}
          summary={
            useDeliveryPoint && selectedDeliveryPoint
              ? `${selectedDeliveryPoint.PName} (${selectedDeliveryPoint.PCode})`
              : "Same as Party Address"
          }
        >
          <div className="flex items-center space-x-3 mb-4">
            <input
              type="checkbox"
              id="useDeliveryPoint"
              checked={useDeliveryPoint}
              onChange={handleUseDeliveryPointChange}
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
            />
            <label htmlFor="useDeliveryPoint" className="font-medium text-gray-700">
              Use a different Delivery Point
            </label>
          </div>

          {useDeliveryPoint && (
            <div className="space-y-4">
              <div className="space-y-2 relative">
                <label
                  htmlFor="deliveryPointSearch"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Select Delivery Point
                </label>
                <input
                  type="text"
                  id="deliveryPointSearch"
                  placeholder="Search for a delivery point..."
                  value={deliveryPointSearchTerm}
                  onChange={(e) => setDeliveryPointSearchTerm(e.target.value)}
                  onFocus={() => setShowDeliveryPointList(true)}
                  className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
                />
                {showDeliveryPointList && (
                  <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                    {displayedDeliveryPoints.length > 0 ? (
                      displayedDeliveryPoints.map((point) => (
                        <li
                          key={point.PId}
                          onClick={() => {
                            handleSelectDeliveryPoint(point);
                            setShowDeliveryPointList(false);
                          }}
                          className="p-2 hover:bg-indigo-100 cursor-pointer"
                        >
                          {point.PName} ({point.PCode})
                        </li>

                      ))
                    ) : (
                      <li className="p-2 text-gray-500 italic">No results found</li>
                    )}
                  </ul>
                )}
              </div>

              {deliveryPointData && (
                <PartyForm
                  party={deliveryPointData}
                  isEditing={isEditingDeliveryPoint}
                  onChange={handleDeliveryPointInputChange}
                  onSave={handleSaveDeliveryPoint}
                  onCancel={handleCancelEditDeliveryPoint}
                  setIsEditing={setIsEditingDeliveryPoint}
                  title="Delivery Point Details"
                />
              )}
            </div>
          )}
        </Accordion>
        <Accordion
          title="Transport Details"
          isOpen={isTransportSectionOpen}
          setIsOpen={setIsTransportSectionOpen}
          summary={
            selectedDespatchThrough
              ? `${selectedDespatchThrough}${vehicleNo ? `, ${vehicleNo}` : ""
              }`
              : "Not specified"
          }
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="despatchThrough"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Despatch Through
              </label>
              <select
                id="despatchThrough"
                value={selectedDespatchThrough}
                onChange={(e) => setSelectedDespatchThrough(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
              >
                <option value="">-- Select --</option>
                {despatchThroughOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label
                htmlFor="vehicleType"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Vehicle Type
              </label>
              <select
                id="vehicleType"
                value={selectedVehicleType}
                onChange={(e) => setSelectedVehicleType(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
              >
                <option value="">-- Select --</option>
                {vehicleTypeOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label
                htmlFor="vehicleNo"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Vehicle No
              </label>
              <input
                type="text"
                id="vehicleNo"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />
            </div>

            <div>
              <label
                htmlFor="ewayBillNo"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                E-way Bill No
              </label>
              <input
                type="text"
                id="ewayBillNo"
                value={ewayBillNo}
                onChange={(e) => setEwayBillNo(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />
            </div>

            <div className="md:col-span-2">
              <label
                htmlFor="despatchRef"
                className="block text-sm font-medium text-gray-700 mb-1" >
                Despatch Ref
              </label>
              <input
                type="text"
                id="despatchRef"
                value={despatchRef}
                onChange={(e) => setDespatchRef(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />
            </div>
          </div>
        </Accordion>
      </div>

      <div className="flex justify-between pt-4 border-t mt-6">
        <button
          onClick={() => setPage(1)}
          className="px-6 py-2 bg-gray-600 text-white rounded">
          Back
        </button>
        <button
          onClick={handleNext}
          disabled={isPage2NextDisabled}
          className="px-6 py-2 bg-indigo-600 text-white rounded disabled:bg-gray-400"
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page2;
